import React from "react";
import { useTheme, THEME_CONFIGS, THEMES } from "../hooks/useTheme";
import Icon from "./Icon";

const ThemeSelector = ({ onSelect }) => {
  const { currentTheme, changeTheme } = useTheme();

  const handleSelect = (theme) => {
    changeTheme(theme);
    if (onSelect) onSelect(theme);
  };

  // Cor do círculo de preview para cada tema
  const getPreviewColor = (theme) => {
    if (theme === "light") return "#ffffff";
    if (theme === "dark") return "#0f172a";
    return THEME_CONFIGS[theme]?.primary;
  };

  const getPreviewBorder = (theme) => {
    if (theme === "light") return "2px solid #d1d5db";
    return "2px solid rgba(255,255,255,0.6)";
  };

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: "0.75rem",
      }}
    >
      {Object.values(THEMES).map((theme) => {
        const config = THEME_CONFIGS[theme];
        const isSelected = theme === currentTheme;

        return (
          <button
            key={theme}
            type="button"
            onClick={() => handleSelect(theme)}
            style={{
              position: "relative",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              gap: "0.5rem",
              padding: "1.25rem 0.75rem",
              border: isSelected
                ? "2px solid var(--color-primary)"
                : "2px solid var(--color-border)",
              borderRadius: "var(--radius-lg)",
              background: isSelected
                ? "var(--color-primary-light)"
                : "var(--color-surface)",
              cursor: "pointer",
              transition: "all var(--transition-base)",
              outline: "none",
            }}
          >
            {/* Círculo de cor */}
            <span
              style={{
                width: "28px",
                height: "28px",
                borderRadius: "50%",
                backgroundColor: getPreviewColor(theme),
                border: getPreviewBorder(theme),
                boxShadow: "0 2px 6px rgba(0,0,0,0.12)",
                flexShrink: 0,
              }}
            />

            {/* Nome */}
            <span
              style={{
                fontSize: "0.85rem",
                fontWeight: isSelected ? 600 : 500,
                color: isSelected
                  ? "var(--color-primary)"
                  : "var(--color-text)",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: "100%",
              }}
            >
              {config?.name}
            </span>

            {/* Badge de seleção */}
            {isSelected && (
              <span
                style={{
                  position: "absolute",
                  top: "6px",
                  right: "6px",
                  width: "20px",
                  height: "20px",
                  borderRadius: "50%",
                  backgroundColor: "var(--color-success)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Icon name="check" size={12} color="white" />
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
};

export default ThemeSelector;
